// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entry-row__name[data-v-c23cdef2] {\n  padding-left: 43px;\n  white-space: nowrap;\n}\n.entry-row__type[data-v-c23cdef2] {\n  font-size: 11px;\n  margin-top: 5px;\n  line-height: 110%;\n}\n.greyed-out[data-v-c23cdef2] {\n  color: #8e9cbb;\n}\n", ""]);
// Exports
module.exports = exports;
